module.exports = __webpack_public_path__ + "img/Weapon_213.8184699c.png";